/* eslint-disable react-hooks/exhaustive-deps */
// React
import { useEffect, useRef, useState } from "react";

// Router
import { useLocation, useNavigate } from "react-router-dom";

// Redux
import { useDispatch, useSelector } from "react-redux";

import {
  disableSwitcher,
  enableSwitcher,
} from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { ownerAccountsViewAll } from "../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import {
  addNewLabelRequest,
  reimbursementRequestApproval,
  reimbursementRequestViewAll,
  removeNewLabelRequest,
  resetToggle,
  setToggle,
} from "../../../redux/features/reimbursementRequest/index";
import { getAllCategories } from "../../../redux/features/sharedResources/sharedResources";

// Utils
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../utils/configurationProvider";
import { standardAccountNumberFormat } from "../../../utils/standardAccountNumberFormat";
import useCategories from "../../../utils/useCategories";
import useCustomSearchParams from "../../../utils/useCustomSearchParams";

// Components
import { toast } from "react-toastify";
import ICONS from "../../../assets/Icons";
import Loader from "../../../components/Loader/Index";
import CommonBankLogo from "../../../components/_utils/CommonBankLogo";
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton";
import ListContainer from "../../../components/_utils/CommonListView/ListContainer";
import CommonAssignLabelPopup from "../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import CommonToast from "../../../components/_utils/CommonToast";
import TopNavComponent from "../../../components/_utils/CommonTopNav/TopNavComponent";
import CardContainer from "../../../components/_utils/CommonViewAllCard/CardContainer";
import TextWithBank from "../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithBank";
import TextWithIcon from "../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import FormatAmount from "../../../components/_utils/FormatAmount/FormatAmount";
import PaginationComponent from "../../../components/_utils/PaginationComponent";
import TickerAnimation from "../../../components/_utils/TickerAnimation";
import useRestrictedAction from "../../../hooks/useRestrictedAction";
import { ReimburseViewAll } from "../../../redux/features/accounts/ReimburseAccount";
import UseHandleScroll from "../../../hooks/useHandleScroll";
import SVGComponent from "../../../components/_utils/SVGComponent";

const parseDateRangeFromUrl = (dateStr) => {
  if (!dateStr) return { start: "", end: "" };
  const parts = dateStr.split(",");
  const start = parts[0] ? Number(parts[0]) : "";
  const end = parts[1] ? Number(parts[1]) : "";
  return { start: isNaN(start) ? "" : start, end: isNaN(end) ? "" : end };
};

const ReimbursementRequestViewAll = ({
  typepop,
  TxnHistoryid,
  TxnHistoryAccountName,
  categoryName,
  type,
  closeReimburseTxnDetailsModal,
  flow,
  alert,
  popupCatName,
}) => {
  // 1️⃣ useDispatch, useNavigate, location
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // 2️⃣ useRef
  const scrollContainerRef = useRef(null);
  const labelActionDispatchedRef = useRef(false);
  const pageSizeChangedRef = useRef(false);

  // 3️⃣ Constants (needed for initial state)
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const { searchParam, handleSearchParams } = useCustomSearchParams({
    pageno: GlobalConfiguration?.lengthCheckOne ?? 1,
    pagesize: PaginationConfiguration.paginationOptions[0],
  });
  const dateFromUrl = parseDateRangeFromUrl(searchParam.get("date"));
  const categoryMapper = useCategories();

  // 4️⃣ useState
  const [dataLoading, setDataLoading] = useState(false);
  const [pendingSearchParams, setPendingSearchParams] = useState(null);
  const [selectedValue, setSelectedValue] = useState(
    type === "requestViewallPopup"
      ? dropdownOptions[0]
      : searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [currentPage, setCurrentPage] = useState(
    type === "requestViewallPopup" ? 1 : Number(searchParam.get("pageno")) || 1,
  );

  const [pageSize, setPageSize] = useState(
    type === "requestViewallPopup"
      ? dropdownOptions[0]
      : searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [mainData, setMainData] = useState([]);
  const [showSearchBar] = useState(false);
  const [accumulatedData, setAccumulatedData] = useState([]);
  const [accountnumberstate, setaccountnumberstate] = useState("");
  const [animateViewAll, setAnimateViewAll] = useState(false);
  const [inputData, setInputData] = useState([]);
  const [requestAmountFilter, setRequestAmountFilter] = useState(
    type === "requestViewallPopup"
      ? ""
      : searchParam.get("requestAmount") || "",
  );
  const [reimbursementAmountFilter, setReimbursementAmountFilter] = useState(
    type === "requestViewallPopup"
      ? ""
      : searchParam.get("reimbursementAmount") || "",
  );
  const [startDateFilter, setStartDateFilter] = useState(
    type === "requestViewallPopup" ? "" : dateFromUrl.start,
  );
  const [endDateFilter, setEndDateFilter] = useState(
    type === "requestViewallPopup" ? "" : dateFromUrl.end,
  );
  const [currentStatus, setCurrentStatus] = useState(
    type === "requestViewallPopup" && flow !== "RequestRejectAll"
      ? ""
      : flow === "RequestRejectAll"
        ? "pending"
        : searchParam.get("status") || "",
  );
  const [accountNumber, setAccountNumber] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [active, setActive] = useState("");
  const [currentCategory, setCurrentCategory] = useState(
    type === "requestViewallPopup" && categoryName
      ? categoryName
      : type === "requestViewallPopup"
        ? ""
        : searchParam.get("category") || (categoryName ? categoryName : ""),
  );
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [labels, setLabels] = useState([]);
  const [ownerAccId, setOwnerAccId] = useState(
    type === "requestViewallPopup" ? "" : searchParam.get("ownerAcc") || "",
  );
  const [beneAccId, setBeneAccId] = useState(
    type === "requestViewallPopup"
      ? (TxnHistoryid ?? "")
      : searchParam.get("beneAcc") || (TxnHistoryid ? TxnHistoryid : ""),
  );
  const [accountName, setAccountName] = useState(
    TxnHistoryAccountName ? TxnHistoryAccountName : "",
  );
  const [displayCategory, setDisplayCategory] = useState(
    type === "requestViewallPopup" ? popupCatName : searchParam.get("dispCat"),
  );
  const [accountNameValue, setAccountNameValue] = useState("");
  const [totalBalanceAmount, setTotalBalanceAmount] = useState(0);
  const [isLabelClicked, setisLabelClicked] = useState(false);
  const [labelTransactions, setLabelTransactions] = useState([]);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);
  const [searchdata, setSearchData] = useState(
    type === "requestViewallPopup" ? "" : searchParam.get("search") || "",
  );
  const [isPaymentMethod, setIsPaymentMethod] = useState(
    type === "requestViewallPopup"
      ? ""
      : searchParam.get("paymentmethod") || "",
  );
  const [loading, setLoading] = useState(true);

  // 5️⃣ useSelector
  const services = useSelector((state) => state.refreshToken.services);
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  const { toggle, storedPage } = useSelector(
    (state) => state.reimbursementRequest,
  );
  const categories = useSelector(
    (state) => state?.sharedResources.categoriesData?.categories,
  );
  const lastScrollTop = useRef(GlobalConfiguration.lengthCheckZero);
  const [direction, setDirection] = useState("");

  const { handleScroll } = UseHandleScroll(setDirection, lastScrollTop);

  // 6️⃣ Callbacks
  const handleSubmit = (key, value) => {
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    setLabelTransactions([]);
    setPendingSearchParams((previous) => ({ ...previous, [key]: value }));
  };

  const isSearchClearBatch =
    pendingSearchParams?.requestAmount === "" &&
    pendingSearchParams?.reimbursementAmount === "";

  useEffect(() => {
    if (!pendingSearchParams) return;
    if (isSearchClearBatch) {
      setSearchData("");
      setActive("");
      setInputData([]);
    }
    if (type !== "requestViewallPopup") {
      const params = new URLSearchParams(location.search);
      Object.entries(pendingSearchParams).forEach(([key, value]) => {
        if (value === "" || value === null || value === undefined) {
          params.delete(key);
        } else {
          params.set(key, value);
        }
      });
      if (isSearchClearBatch) params.delete("search");
      params.set("pageno", GlobalConfiguration.lengthCheckOne);
      params.set("pagesize", pageSize);
      navigate(
        { pathname: location.pathname, search: `?${params.toString()}` },
        { replace: true, state: location.state },
      );
    }
    setPendingSearchParams(null);
  }, [
    pendingSearchParams,
    isSearchClearBatch,
    type,
    location,
    navigate,
    pageSize,
  ]);

  const handleSelect = (value) => {
    if (value !== pageSize) {
      pageSizeChangedRef.current = true;
    }
    setSelectedValue(value);
    setPageSize(value);
    const nextPage = Number(storedPage) || currentPage;
    setCurrentPage(nextPage);
    if (type !== "requestViewallPopup") {
      handleSearchParams("pagesize", value);
      handleSearchParams("pageno", nextPage);
    }
    setIsOpen(!isOpen);
  };

  const handleAction = async () => {
    setAnimateViewAll(false);
    if (searchUserTextDebounce !== "") {
      setMainData([]);
    }
    if (currentStatus === "require approval") {
      try {
        setLoading(true);

        const responseApproval = await dispatch(
          reimbursementRequestApproval({
            page_no: currentPage,
            page_size: pageSize,
            category: currentCategory,
          }),
        );

        const newApprovalData = responseApproval?.payload?.requests || [];

        setMainData(responseApproval?.payload);
        setAccumulatedData(newApprovalData);
        setTotalBalanceAmount(responseApproval?.payload?.total_amount || 0);
        setLoading(false);
        if (
          pageSizeChangedRef.current &&
          newApprovalData?.length &&
          isLabelClicked
        ) {
          pageSizeChangedRef.current = false;
          setLabelTransactions((prev) => {
            const idsOnPage = new Set(newApprovalData.map((r) => r.request_id));
            return prev.filter((id) => idsOnPage.has(id));
          });
        }
      } catch (error) {
        setAccumulatedData([]);
        setMainData([]);
        setLoading(false);
      }
    } else {
      try {
        setLoading(true);
        let queryParams = {
          page_no: currentPage,
          page_item_count:
            flow === "RequestRejectAll"
              ? PaginationConfiguration.paginationBig
              : pageSize,
        };

        if (currentStatus) {
          queryParams.lifecycle_status = currentStatus;
        }

        if (
          startDateFilter &&
          endDateFilter &&
          !isNaN(Number(startDateFilter)) &&
          !isNaN(Number(endDateFilter))
        ) {
          queryParams.start_date =
            startDateFilter + GlobalConfiguration.day_in_seconds;
          queryParams.end_date =
            endDateFilter + GlobalConfiguration.day_in_seconds;
        }

        if (ownerAccId && ownerAccId !== "") {
          queryParams.owner_account_id = [ownerAccId];
        }
        if (beneAccId && beneAccId !== "") {
          queryParams.beneficiary_account_id = [beneAccId];
        }

        if (currentCategory) {
          queryParams.category_id = currentCategory;
        }

        if (requestAmountFilter) {
          queryParams.request_amount = requestAmountFilter;
        }
        if (reimbursementAmountFilter) {
          queryParams.reimbursement_amount = reimbursementAmountFilter;
        }

        if (searchdata !== "") {
          queryParams.additional_data = searchdata;
          // queryParams.category_name = "value";
        }

        const response = await dispatch(
          reimbursementRequestViewAll(queryParams),
        );
        setMainData(response?.payload);
        const newData = response?.payload?.requests || [];
        setAccumulatedData(newData);
        setLabels(response?.payload?.summary?.available_labels);
        setLoading(false);
        setTotalBalanceAmount(Number(response?.payload?.total_amount || 0));
        if (pageSizeChangedRef.current && newData?.length && isLabelClicked) {
          pageSizeChangedRef.current = false;
          setLabelTransactions((prev) => {
            const idsOnPage = new Set(newData.map((r) => r.request_id));
            return prev.filter((id) => idsOnPage.has(id));
          });
        }
      } catch (error) {
        setAccumulatedData([]);
        setMainData([]);
        setLoading(false);
        setTotalBalanceAmount(0);
      }
    }
  };

  // 7️⃣ useEffect
  useEffect(() => {
    if (isSearchClearBatch && searchdata) return;
    handleAction();
  }, [
    currentPage,
    pageSize,
    currentStatus,
    isPaymentMethod,
    startDateFilter,
    endDateFilter,
    accountnumberstate,
    ownerAccId,
    beneAccId,
    searchdata,
    currentCategory,
    requestAmountFilter,
    reimbursementAmountFilter,
    markerData,
  ]);

  const displayDate = (dateString) => {
    const date = new Date(dateString);
    const timestamp = Math.floor(date.getTime() / 1000);

    return timestamp;
  };

  const handleFilterDateRange = (date) => {
    if (date) {
      const [start, end] = date;
      const startTs = displayDate(start);
      const endTs = displayDate(end);
      setStartDateFilter(startTs);
      setEndDateFilter(endTs);
      handleSubmit("date", `${startTs},${endTs}`);
    } else {
      setStartDateFilter("");
      setEndDateFilter("");
      handleSubmit("date", "");
    }
  };

  useEffect(() => {
    dispatch(enableSwitcher());
    dispatch(resetToggle());
    return () => {
      dispatch(disableSwitcher());
    };
  }, [markerData]);

  const handlePagination = (page) => {
    setCurrentPage(page);
    if (type !== "requestViewallPopup") {
      handleSearchParams("pageno", page);
    }
    if (isLabelClicked) {
      setLabelTransactions([]);
    }
  };

  const fetchData = async () => {
    setDataLoading(true);

    let response;
    let data = [];

    try {
      switch (active) {
        case "Category":
          response = await dispatch(
            getAllCategories({ search_string: searchUserTextDebounce }),
          );
          data =
            response?.payload?.categories?.map((itm) => ({
              id: itm.id,
              Category: itm.name,
              Description: itm?.description || "Not given",
            })) || [];
          break;

        case "Reimbursement account":
          response = await dispatch(
            ReimburseViewAll({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.reimbursement_accounts?.map((itm) => ({
                id: itm.id,
                Name: itm.name,
                Account_number: itm.bank_acc_no,
                display: itm.name,
                IFSC_code: itm.ifsc_code,
                Contact_number: itm.contact_no,
                Email_ID: itm.email_id,
              })) || [];
          }
          break;
        case "Search":
          if (searchUserTextDebounce === "") {
            setSearchData("");
          } else {
            setSearchData(searchUserTextDebounce);
          }
          setDataLoading(false);
          break;

        case "Owner account":
          response = await dispatch(
            ownerAccountsViewAll({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.owner_accounts?.map((itm) => ({
                id: itm.id,
                Account_number: itm.bank_acc_no,
                display: itm.bank_acc_no,
                Name: itm.name,
                IFSC_code: itm.ifsc_code,
                Email_ID: itm.email_id,
              })) || [];
          }
          break;
        case "Labels":
          data = labels
            ?.filter((itm) => {
              if (itm.includes(searchUserTextDebounce)) return true;
              else return false;
            })
            ?.map((val) => {
              return { id: val, Label: val, display: val };
            });
          setInputData(data);
          setDataLoading(false);
          break;

        default:
          data = [];
          break;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      data = [];
    } finally {
      setInputData([...data]);
      setDataLoading(false);
    }
  };

  useEffect(() => {
    if (active?.length) {
      fetchData();
    }
  }, [active]);

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const handleClose = () => {
    setIsLabelPopupOpen(false);
    if (labelActionDispatchedRef.current) {
      handleAction();
      setLabelTransactions([]);
      setisLabelClicked(false);
      labelActionDispatchedRef.current = false;
    }
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds = toArray(labelTransactions);
    const res = await dispatch(
      addNewLabelRequest({ record_ids: recordIds, labels: labelsToAssign }),
    );
    if (addNewLabelRequest.fulfilled.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await handleAction();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (addNewLabelRequest.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLoading(false);
    if (addNewLabelRequest?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(labelTransactions);
    const res = await dispatch(
      removeNewLabelRequest({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );
    if (removeNewLabelRequest.fulfilled.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await handleAction();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (removeNewLabelRequest.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLoading(false);
    if (removeNewLabelRequest?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleToggle = (newToggleValue) => {
    if (loading) {
      setAnimateViewAll(false);
    } else {
      setAnimateViewAll(true);
    }
    if (toggle !== newToggleValue) {
      const scrollTarget = scrollContainerRef.current || window;
      scrollTarget.scrollTo({ top: 0, behavior: "smooth" });

      if (!showSearchBar) {
        dispatch(setToggle(newToggleValue));
      }

      if (type !== "requestViewallPopup") {
        handleSearchParams("pageno", GlobalConfiguration?.lengthCheckOne ?? 1);
      }
    }
  };

  const isHistoryAccountLocked = type === "requestViewallPopup";
  const isHistoryCategoryLocked = isHistoryAccountLocked && !!categoryName;
  const isStatusLocked = flow === "RequestRejectAll";

  const hasSearchParameters = Boolean(
    searchdata?.length ||
    // searchUserTextDebounce ||
    requestAmountFilter ||
    reimbursementAmountFilter ||
    ownerAccId ||
    (!isHistoryAccountLocked && beneAccId) ||
    (!isHistoryCategoryLocked && currentCategory),
  );
  const hasFilterParameters = Boolean(
    startDateFilter || endDateFilter || (!isStatusLocked && currentStatus),
  );
  const clearParameterVisibility = hasSearchParameters || hasFilterParameters;

  const handleClearParams = (e) => {
    e?.stopPropagation();
    setAnimateViewAll(false);
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    setLabelTransactions([]);
    setSearchUserTextDebounce("");
    setRequestAmountFilter("");
    setReimbursementAmountFilter("");
    setaccountnumberstate("");
    setOwnerAccId("");
    setAccountNumber("");
    setStartDateFilter("");
    setEndDateFilter("");
    setIsPaymentMethod("");
    if (!isHistoryAccountLocked) {
      setBeneAccId("");
      setAccountName("");
      setAccountNameValue("");
    }
    if (!isHistoryCategoryLocked) setCurrentCategory("");
    if (!isStatusLocked) setCurrentStatus("");

    // Use the same URL update as Clear all, preserving the popup's scope.
    setPendingSearchParams({
      requestAmount: "",
      reimbursementAmount: "",
      ownerAcc: "",
      date: "",
      paymentmethod: "",
      ...(!isHistoryAccountLocked && { beneAcc: "" }),
      ...(!isHistoryCategoryLocked && { category: "" }),
      ...(!isStatusLocked && { status: "" }),
    });
  };

  const { showRestrictedAction } = useRestrictedAction();

  const actionRestricted = () => {
    showRestrictedAction();
  };

  const statuses = ["require approval", "pending", "approved", "rejected"];

  const hasARequest = services?.includes("AReimbursementRequest");

  const filteredStatuses = statuses.filter((status) => {
    // const hasAdmin = services?.includes("Admin");

    const hasCTxn = services?.includes("CReimbursementTxn");

    if ((hasARequest && hasCTxn) || (hasARequest && !hasCTxn)) {
      if (status === "require approval") return true;
    }

    if (hasCTxn && !hasARequest) {
      if (status === "pending") return true;

      if (status === "require approval") return false;
    }

    if (hasARequest && status === "pending") return false;

    return true;
  });

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--awaiting)";
      case "denied":
      case "failed":
        return "var(--failed)";
      case "abandoned":
        return "var(--abandoned)";
      case "rejected":
        return "var(--failed)";
      default:
        return "var(--settled)";
    }
  };

  const getFilterItems = () => {
    const checkerFilters = [
      {
        name: "Search",
        isMulti: false,
        value: searchdata,
        setValue: (val) => {
          setCurrentPage(1);
          setSearchData(val);
        },
        isDropdown: false,
        isDisabled: loading,
      },
      {
        name: "Owner account",
        short_name: "Own. Acc",
        isMulti: false,
        value: ownerAccId,
        displayValue: standardAccountNumberFormat(accountNumber, true),
        setValue: (val) => {
          setCurrentPage(1);
          setOwnerAccId(val);
          if (!val) setAccountNumber("");
          handleSubmit("ownerAcc", val);
        },
        setDisplayValue: setAccountNumber,
        valueType: "string",
        isDropdown: true,
        isDisabled: loading ? true : false,
      },
      {
        name: "Reimbursement account",
        short_name: "Reimb A/c",
        isMulti: false,
        value: beneAccId,
        displayValue:
          accountName?.toLowerCase() || accountNameValue?.toLowerCase(),
        setValue: (val) => {
          setCurrentPage(1);
          setBeneAccId(val);
          if (!val) {
            setAccountName("");
            setAccountNameValue("");
          }
          handleSubmit("beneAcc", val);
        },
        setDisplayValue: (val) => {
          setAccountName(val);
          setAccountNameValue(val);
        },
        isDropdown: true,
        valueType: "string",
        isDisabled:
          type === "requestViewallPopup" ? true : loading ? true : false,
      },
    ];
    let result = [];
    if (services.includes("AReimbursementRequest")) result = checkerFilters;
    return [
      ...result,
      {
        name: "Approved amount",
        short_name: "App Amt - INR",
        isMulti: false,
        value: reimbursementAmountFilter,
        setValue: (val) => {
          setCurrentPage(1);
          setReimbursementAmountFilter(val);
          handleSubmit("reimbursementAmount", val);
        },
        displayValue: FormatAmount({
          price: reimbursementAmountFilter,
        }),
        isDropdown: false,
        isDisabled: loading,
        valueType: "number",
      },
      {
        name: "Requested amount",
        short_name: "Req Amt - INR",
        isMulti: false,
        value: requestAmountFilter,
        setValue: (val) => {
          setCurrentPage(1);
          setRequestAmountFilter(val);
          handleSubmit("requestAmount", val);
        },
        displayValue: FormatAmount({
          price: requestAmountFilter,
        }),
        isDropdown: false,
        isDisabled: loading,
        valueType: "number",
      },
      {
        name: "Category",
        short_name: "Cat",
        valueType: "string",
        isMulti: false,
        value: currentCategory,
        displayValue: displayCategory,
        setValue: (val) => {
          const c = categories.filter((x) => x.id === val)[0]?.name ?? "";
          setDisplayCategory(c);
          setCurrentPage(1);
          setCurrentCategory(val);
          handleSubmit("category", val);
          handleSubmit("dispCat", c);
        },
        isDropdown: true,
        isDisabled:
          type === "requestViewallPopup" && categoryName
            ? true
            : loading
              ? true
              : false,
      },
    ];
  };
  return (
    <div
      id={`${type !== "requestViewallPopup" && "beneScrollContainer"} `}
      className={`bg-primary-bg ${type === "requestViewallPopup" && "h-full"} ${flow === "RequestRejectAll" && "relative"} flex flex-col webview ${
        typepop === "transactionHistorypopup" ? "h-full-height" : ""
      }`}
    >
      {accumulatedData?.length > GlobalConfiguration.lengthCheckZero && (
        <div
          className={` ${type === "requestViewallPopup" ? "absolute" : "fixed"} rounded-none ${loading && "hidden"} bg-primary-nav ${showInnerSearchBar ? "z-z-index-content pointer-events-none" : "z-z-index-dropdown"} bottom-bottom-base w-full  ${
            typepop === "transactionHistorypopup"
              ? "bottom-bottom-base w-full rounded-none Qmd:bottom-bottom-sm Qmd:w-pagination-width Qmd:rounded-b-border-radius-md"
              : "bottom-bottom-base w-full rounded-none"
          }`}
        >
          <div
            className={`${
              showInnerSearchBar &&
              flow !== "RequestRejectAll" &&
              "opacity-light-opacity bg-PopUp-BackDrop h-full"
            }`}
          >
            <PaginationComponent
              handleSelect={handleSelect}
              selectedValue={selectedValue}
              data={mainData}
              pageSize={pageSize}
              dropdownOptions={dropdownOptions}
              handlePagination={handlePagination}
              currentPage={currentPage}
              setIsOpen={setIsOpen}
              typePopup={typepop === "transactionHistorypopup"}
            />
          </div>
        </div>
      )}

      {isLabelPopupOpen && (
        <div className="fixed left-left-base w-full top-top-base h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex">
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated transactions."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            LabelAccounts={labelTransactions}
            isLabelPopupOpen={isLabelPopupOpen}
            filteredData={accumulatedData
              ?.filter((r) => labelTransactions.includes(r.request_id))
              ?.map((r) => ({ ...r, id: r.request_id }))}
            onClose={handleClose}
            loading={loading}
            setLoading={setLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
            type="viewall"
          />
        </div>
      )}
      {/* Main code start here  */}
      <div
        className={`bg-primary-bg flex ${type === "requestViewallPopup" && "relative"} flex-col  ${
          typepop === "transactionHistorypopup" ||
          type === "requestViewallPopup"
            ? "h-full"
            : "h-screen"
        }`}
        id="benetxnmain"
      >
        <div
          className={`relative z-z-index-overlay ${direction === "down" ? "bg-primary-bg" : "bg-primary-nav"} ${type === "requestViewallPopup" ? "hidden" : "block"} Qsmd:h-navbar-breadcrumb-height flex-shrink-0`}
        ></div>
        <div
          className={`bene_div_container z-z-index-header Qmd:shadow-box-shadow-bottom Qmd:bg-primary-nav bg-primary-nav-act ${typepop === "transactionHistorypopup" || type === "requestViewallPopup" ? " w-full Qmd:w-full-popup-width" : "w-full-width"} relative `}
        >
          <TopNavComponent
            direction={direction}
            topNavHeader={totalBalanceAmount}
            topNavSubText="Total amount"
            handleBack={() => {
              if (isLabelClicked) {
                setisLabelClicked(false);
              } else {
                navigate(-1);
              }
            }}
            ispagination={
              accumulatedData?.length <= GlobalConfiguration.lengthCheckZero
                ? false
                : true
            }
            isToggleNeeded={true}
            toggleProps={{
              state: toggle,
              title: toggle ? "Grid View" : "List View",
              isDisabled: false,
              handleClick: () => {
                handleToggle(!toggle);
              },
            }}
            filteredSearchProps={{
              isSortDisabled: loading,
              isFilterDisabled: loading,
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isSearchDisabled: loading,
              onSearchInput: handleSearch,
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search reimbursement request",
              filterPlaceholder: "Category specific details",
              filterItems: getFilterItems(),
              filters: [
                {
                  name: "Approval status",
                  filterType: "dropdown",
                  variant: "single",
                  value: currentStatus,
                  options: filteredStatuses.map((status) => status),
                  dropdownPlaceHolder:
                    currentStatus === "deleted"
                      ? "Discard"
                      : currentStatus === "rejected"
                        ? "Rejected"
                        : "Select status",
                  isDisabled: flow === "RequestRejectAll" ? true : false,
                  statusPop: true,
                  handleChange: (val) => {
                    setAnimateViewAll(false);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setCurrentStatus(val);
                    handleSubmit("status", val);
                  },
                },

                {
                  name: "Date range",
                  filterType: "calender",
                  variant: "range",
                  size: "small",
                  value: startDateFilter && endDateFilter,
                  isDisabled: false,
                  startDate: startDateFilter
                    ? new Date(startDateFilter * 1000)
                    : startDateFilter,
                  endDate: endDateFilter
                    ? new Date(endDateFilter * 1000)
                    : endDateFilter,
                  handleChange: (date) => {
                    setAnimateViewAll(false);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    handleFilterDateRange(date);
                  },
                },
              ],

              isFilterClearAllDisabled: loading || !hasFilterParameters,
              isSearchClearAllDisabled: loading || !hasSearchParameters,

              inputData: inputData,
              active: active,
              setActive: setActive,
              loading: loading || dataLoading,
              setLoading: (e) => {},
              isShowFilter: true,
              isShowSortBy: false,
              loadingData: dataLoading,
            }}
          />
        </div>
        {/* Card section  */}
        {showInnerSearchBar && (
          <div class="absolute bg-PopUp-BackDrop opacity-light-opacity pointer-events-none w-full h-full z-z-index-content Qsmd:z-z-index-header"></div>
        )}

        <div
          ref={scrollContainerRef}
          onScroll={handleScroll}
          id="benetxnViewallScrollContainer"
          className={` flex-1 overflow-x-hidden ${
            showInnerSearchBar
              ? "overflow-y-hidden h-screen  opacity-light-opacity bg-PopUp-BackDrop cursor-pointer-none pointer-events-none"
              : flow === "RequestRejectAll"
                ? "pb-[var(--pagination-height)]"
                : "mb-[var(--pagination-height)] scroll-py-top_md "
          } ${loading && accumulatedData?.length ? "overflow-y-hidden mt-margin-md" : "overflow-y-auto"}`}
        >
          {loading ? (
            <div className="loader-container m-auto flex items-center justify-center h-full">
              <Loader />
            </div>
          ) : accumulatedData?.length ? (
            /* Outer viewport container remains static — scrollbar stays locked on the right edge */
            <div className="w-full flex-1">
              {!toggle ? (
                /* Grid view container slides smoothly in from the left side */
                <div
                  className={`${animateViewAll ? "animate-slide-prev" : ""} standard-card-alignment gap-x-gap-sm gap-y-gap-md`}
                  onAnimationEnd={() => setAnimateViewAll(false)}
                >
                  {accumulatedData?.map((transactions) => {
                    const categoryIcon = categoryMapper(
                      transactions.category_id?.category_id,
                    );
                    const requestedAmount = Number(
                      transactions?.requested_amount ?? "",
                    );
                    const approvedAmount = Number(
                      transactions?.reimbursement_amount ?? "",
                    );

                    const requestedAmountExceedsApproved =
                      requestedAmount > approvedAmount;

                    return (
                      <CardContainer
                        filterRef={scrollContainerRef}
                        key={transactions?.request_id}
                        isNoCursorRequired={
                          flow === "RequestRejectAll" ? true : false
                        }
                        onClickHandler={() => {
                          if (
                            showInnerSearchBar ||
                            flow === "RequestRejectAll"
                          ) {
                            return;
                          } else {
                            if (alert === "alertpopup") {
                              actionRestricted();
                            } else {
                              navigate(
                                `/reimbursement_transaction_dashboard/reimbursement_request_view_all/reimbursement_request_detail_page/${transactions?.request_id}`,
                                {
                                  state: {
                                    isViewAll:
                                      location.pathname.includes("view_all"),
                                  },
                                },
                              );
                            }

                            if (
                              type === "requestViewallPopup" &&
                              alert !== "alertpopup"
                            ) {
                              closeReimburseTxnDetailsModal();
                            }
                          }
                        }}
                        isDisabled={showInnerSearchBar}
                      >
                        <card-body>
                          <TextWithIcon
                            type="Amount"
                            fontWeight="semibold"
                            text={transactions?.requested_amount}
                            subText="Requested amount"
                            textColor={
                              requestedAmountExceedsApproved &&
                              transactions?.lifecycle_status === "approved"
                                ? "var(--queued)"
                                : "var(--text-primary)"
                            }
                          />
                          <TextWithIcon
                            type={
                              transactions?.lifecycle_status === "approved"
                                ? "Amount"
                                : "Text"
                            }
                            fontWeight="semibold"
                            text={
                              transactions?.lifecycle_status === "approved"
                                ? transactions?.reimbursement_amount
                                : "N/A"
                            }
                            subText="Approved amount"
                            textColor={
                              transactions?.lifecycle_status === "approved"
                                ? "var(--settled)"
                                : "var(--text-primary)"
                            }
                          />

                          <TextWithIcon
                            text={
                              transactions?.beneficiary_account_name || "N/A"
                            }
                            type="Text"
                            subText="Requested by"
                            fontWeight="normal"
                            textColor="var(--text-primary)"
                          />

                          <TextWithBank
                            text={
                              (hasARequest &&
                                transactions?.lifecycle_status === "pending") ||
                              currentStatus === "require approval"
                                ? "require approval"
                                : transactions?.lifecycle_status || "N/A"
                            }
                            subText={"Status"}
                            textCase={"capitalize"}
                            fontWeight={"semibold"}
                            textColor={
                              transactions?.lifecycle_status === "N/A"
                                ? "var(--text-primary)"
                                : getStatusColor(transactions?.lifecycle_status)
                            }
                            type="Text"
                            src={categoryIcon.url}
                            imgColor={categoryIcon.colour}
                            ifscCode={
                              transactions.beneficiary_account_ifsc_code
                            }
                          />
                        </card-body>
                      </CardContainer>
                    );
                  })}
                </div>
              ) : (
                /* List view container slides smoothly in from the right side */
                <div
                  style={{
                    display: "grid",
                    width: "var(--width-full)",
                    gridTemplateColumns:
                      "repeat(auto-fill, var(--standard-listview-width))",
                    padding: "var(--padding-md)",
                    justifyContent: "center",
                  }}
                  className={`${animateViewAll ? "animate-slide-next" : ""}  gap-x-gap-sm gap-y-gap-lg`}
                  onAnimationEnd={() => setAnimateViewAll(false)}
                >
                  {accumulatedData?.map((transactions) => {
                    const categoryIcon = categoryMapper(
                      transactions?.category_id?.category_id,
                    );
                    const requestedAmount = Number(
                      transactions?.requested_amount ?? "",
                    );
                    const approvedAmount = Number(
                      transactions?.reimbursement_amount ?? "",
                    );

                    const requestedAmountExceedsApproved =
                      requestedAmount > approvedAmount;

                    console.log(transactions?.lifecycle_status);

                    return (
                      <ListContainer
                        hoverHeight={
                          GlobalConfiguration?.reimbursementRequestListHoverHeight
                        }
                        key={transactions?.request_id}
                        filterRef={scrollContainerRef}
                        onClickHandler={() => {
                          if (showInnerSearchBar) {
                            return;
                          } else {
                            if (alert === "alertpopup") {
                              actionRestricted();
                            } else {
                              navigate(
                                `/reimbursement_transaction_dashboard/reimbursement_request_view_all/reimbursement_request_detail_page/${transactions?.request_id}`,
                                {
                                  state: {
                                    isViewAll:
                                      location.pathname.includes("view_all"),
                                  },
                                },
                              );
                              if (
                                type === "requestViewallPopup" &&
                                alert !== "alertpopup"
                              ) {
                                closeReimburseTxnDetailsModal();
                              }
                            }
                          }
                        }}
                      >
                        <list-body>
                          <div className="flex w-full flex-col gap-y-gap-sm pl-padding-sm py-padding-sm">
                            <div className="flex w-full min-w-0 items-center justify-between gap-x-gap-sm">
                              <p className="min-w-0 flex-1 truncate text-font-sm font-normal text-text-primary">
                                <TickerAnimation
                                  text={
                                    transactions?.beneficiary_account_name ??
                                    "N/A"
                                  }
                                />
                              </p>
                              <div className="flex flex-shrink-0 items-center gap-x-gap-sm rounded-l-border-radius-md bg-text-primary px-padding-sm py-padding-xs">
                                <CommonBankLogo
                                  variant="small"
                                  ifsc={
                                    transactions.beneficiary_account_ifsc_code
                                  }
                                />
                                <div className="h-icon-sm border-l border-primary-bg"></div>
                                <SVGComponent
                                  color={categoryIcon?.colour}
                                  url={categoryIcon?.url}
                                  height="var(--icon-sm)"
                                  width="var(--icon-sm)"
                                />
                              </div>
                            </div>

                            <div className="flex w-full items-center">
                              <div
                                className={`flex min-w-0 flex-col gap-y-gap-xs w-1/2 pr-padding-sm`}
                              >
                                <p className="truncate whitespace-nowrap text-font-xs font-semibold text-text-primary">
                                  INR{" "}
                                  <FormatAmount
                                    price={Number(
                                      transactions?.requested_amount,
                                    )}
                                  />
                                </p>
                                <p className="text-font-xxs text-text-secondary">
                                  Requested amount
                                </p>
                              </div>

                              <div className="h-[var(--icon-lg)] border-l border-primary-bg"></div>
                              {transactions?.lifecycle_status === "approved" ? (
                                <div className="flex w-1/2 min-w-0 flex-col items-end gap-y-gap-xs pl-padding-sm pr-padding-sm">
                                  <p
                                    className={`truncate whitespace-nowrap text-font-xs font-semibold ${requestedAmountExceedsApproved ? "text-queued" : "text-settled"}`}
                                  >
                                    INR{" "}
                                    <FormatAmount
                                      price={Number(
                                        transactions?.reimbursement_amount,
                                      )}
                                    />
                                  </p>
                                  <p className="text-font-xxs text-text-secondary">
                                    Approved amount
                                  </p>
                                </div>
                              ) : (
                                <div className="flex w-1/2 min-w-0 flex-col items-end gap-y-gap-xs pl-padding-sm pr-padding-sm">
                                  <p className="truncate whitespace-nowrap text-font-xs font-semibold text-text-secondary">
                                    N/A
                                  </p>
                                  <p className="text-font-xxs text-text-secondary">
                                    Approved amount
                                  </p>
                                </div>
                              )}
                            </div>
                          </div>
                        </list-body>

                        <list-hover>
                          <div className="flex min-w-0 flex-col gap-y-gap-xs px-padding-sm py-padding-sm">
                            <p
                              className="truncate whitespace-nowrap text-font-xs font-semibold capitalize"
                              style={{
                                color:
                                  transactions?.lifecycle_status === "N/A"
                                    ? "var(--text-primary)"
                                    : getStatusColor(
                                        transactions?.lifecycle_status,
                                      ),
                              }}
                            >
                              {(hasARequest &&
                                transactions?.lifecycle_status === "pending") ||
                              currentStatus === "require approval"
                                ? "require approval"
                                : transactions?.lifecycle_status || "N/A"}
                            </p>
                            <p className="text-font-xxs text-text-secondary">
                              Approval status
                            </p>
                          </div>
                        </list-hover>
                      </ListContainer>
                    );
                  })}
                </div>
              )}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center m-auto  Qsmd:mt-margin-base h-height-full">
              <div className="flex flex-col gap-gap-sm items-center justify-center">
                <img
                  src={ICONS?.NO_DATA_FOUND}
                  alt="No accounts found"
                  className="w-graphic-width-md h-graphic-rectangle-height-md"
                />
                <p className="text-text-primary text-font-sm font-normal">
                  No data found.
                </p>
                {clearParameterVisibility ? (
                  <div>
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={handleClearParams}
                      enabledTextColor="var(--text-primary)"
                    />
                  </div>
                ) : null}
              </div>

              {isLabelClicked ? (
                <div
                  className={`h-navbar-breadcrumb-height mb-margin-xl block Qmd:hidden ${
                    typepop === "RejectAllTransactionPopup" &&
                    "mb-margin-bottom-pop-up"
                  }`}
                ></div>
              ) : null}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReimbursementRequestViewAll;
